module.exports = __webpack_public_path__ + "media/EN-JeParticipe2.934fe6f2.mp3";